<template>
  <div class="yzx-version-comparison">
    <div class="title-box">
      <p class="title">版本权益对比</p>
      <p class="sub-title">AI提效+数据降本，智能管理让纸箱厂利润飙升！</p>
    </div>
    <comparTable></comparTable>
    <!-- <div class="img-box">
      <img src="@/assets/images/yzxBuyEntrance/version-compar.png" alt="" />
    </div> -->

    <!-- <div
      class="img-container"
      :class="{ expanded: isExpanded }"
      @scroll="handleScroll"
    >
      <div class="img-wrapper">
        <img
          src="@/assets/images/yzxBuyEntrance/version-compar.png"
          alt="版本对比图"
          @load="handleImageLoad"
        />
      </div> -->

    <!-- <div class="fade-overlay" v-if="!isExpanded"></div>

     
      <div class="button-container">
        <button class="expand-btn" @click="toggleExpand">
          {{ isExpanded ? '收起' : '展开查看完整图片' }}
          <span class="icon" :class="{ expanded: isExpanded }">↓</span>
        </button>
      </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import comparTable from './comparTable.vue'
export default {
  name: 'comparison',
  components: { comparTable },
  data() {
    return {
      isExpanded: true,
      imageLoaded: true
    }
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    },
    handleImageLoad() {
      this.imageLoaded = true
    },
    handleScroll(event) {
      // 可选：监听滚动事件
      console.log('Scroll position:', event.target.scrollLeft)
    }
  }
}
</script>

<style lang="scss" scoped>
.yzx-version-comparison {
  background: #fff;
  .title-box {
    background: #ffffff;
    text-align: center;
    padding: 30px 10px;
    .title {
      font-weight: 500;
      font-size: 32px;
      color: #333333;
    }
    .sub-title {
      font-weight: 400;
      font-size: 24px;
      color: #666666;
      padding-top: 12px;
    }
  }
  .img-box {
    overflow: hidden;
    padding-left: 20px;
    img {
    }
  }

  /* 图片容器 */
  .img-container {
    position: relative;
    width: 100%;
    height: 120px; /* 默认高度，显示20% */
    overflow: hidden;
    border-radius: 8px;
    transition: height 0.3s ease;
    background: #f5f5f5;
  }

  .img-container.expanded {
    height: 500px; /* 展开后的高度，根据图片实际高度调整 */
    overflow-x: auto; /* 允许水平滚动 */
  }

  /* 图片包装器 */
  .img-wrapper {
    width: max-content; /* 让图片保持原始宽度 */
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .img-wrapper img {
    width: auto;
    height: 500px; /* 图片的实际高度 */
    display: block;
    transition: transform 0.3s ease;
  }

  /* 渐变遮罩层 */
  .fade-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: linear-gradient(transparent, rgba(255, 255, 255, 0.9));
    pointer-events: none;
  }

  /* 按钮容器 */
  .button-container {
    text-align: center;
    margin-top: 16px;
  }

  .expand-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: #1890ff;
    color: white;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  .expand-btn:hover {
    background: #40a9ff;
    transform: translateY(-1px);
  }

  .expand-btn .icon {
    transition: transform 0.3s ease;
  }

  .expand-btn .icon.expanded {
    transform: rotate(180deg);
  }

  /* 滚动条样式 */
  .img-container::-webkit-scrollbar {
    height: 6px;
  }

  .img-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  .img-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  .img-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
}
@media (min-width: 751px) and (max-width: 960px) {
}
@media (min-width: 961px) {
}
</style>
